import { ref, onMounted, onUpdated, onBeforeUnmount, type Ref } from 'vue'
// 全文提示及关键字段实际文字宽度，只修改显示属性，不触碰业务数据或事件。
export function useOrderCellTitles(root:Ref<HTMLElement|null|undefined>,enabled:()=>boolean) {
 const widths=ref<Record<string,number>>({})
 let frame=0,observer:MutationObserver|undefined,stopped=false
 const measure=()=>{frame=0;if(stopped || !enabled() || !root.value)return
  root.value.querySelectorAll<HTMLElement>('td.order-fit-flex,th').forEach(cell=>{
   const value=cell.querySelector<HTMLElement>('.list-order-number')?.title || cell.textContent?.trim() || '';if(cell.title!==value)cell.title=value
  })
  const next:Record<string,number>={}
  root.value.querySelectorAll<HTMLElement>('td.order-fit-critical,td.order-fit-time').forEach(cell=>{
   if(cell.closest('[data-action-scope]')!==root.value || !cell.offsetWidth)return
   const key=cell.dataset.orderFitKey;if(!key)return
   const scale=cell.getBoundingClientRect().width/cell.offsetWidth || 1
   // 分别量原来的状态块；不把一列中多条状态拼成一个虚假的长字符串。
   const lines=cell.querySelectorAll('div').length?Array.from(cell.querySelectorAll('div')).filter(e=>!e.querySelector('div')):[cell]
   let content=0
   for(const line of lines){const range=document.createRange();range.selectNodeContents(line);content=Math.max(content,range.getBoundingClientRect().width/scale)}
   next[key]=Math.max(next[key] || 0,Math.ceil(content+8))
  })
  if(JSON.stringify(next)!==JSON.stringify(widths.value))widths.value=next
 }
 const schedule=()=>{if(!stopped && enabled() && !frame)frame=requestAnimationFrame(measure)}
 onMounted(()=>{if(root.value?.nodeType===1 && typeof MutationObserver!=='undefined'){observer=new MutationObserver(schedule);observer.observe(root.value,{subtree:true,childList:true,characterData:true})}schedule()})
 onUpdated(schedule);onBeforeUnmount(()=>{stopped=true;observer?.disconnect();if(frame)cancelAnimationFrame(frame)})
 return widths
}
